import { Box, CircularProgress } from "@mui/material"
import React, { useContext } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { CustomBottomNavigation } from "../../../../../components/buttons/navigate-button/CustomBottomNavigation"
import { pagesUrl } from "../../../../../core/appConstants"
import { BSBimModelListContext } from "../../../../../core/context/beem-shot/BSBimModel/BSBimModelContextList"
import { ProjectContext } from "../../../../../core/context/project/ProjectContext"
import { resolveUrl } from "../../../../../core/services/http-service"
import { BSBimModelList } from "./components/BSBimModelList"

export function BSBimModelTab(): React.JSX.Element {
  const navigate = useNavigate()
  const { projectId } = useParams()

  const { project } = useContext(ProjectContext)
  const { bsBimModelListByProject, isLoaded } = useContext(BSBimModelListContext)

  return (
    <Box height="100%">
      {!project || !isLoaded ? (
        <Box height="100%" display="flex" alignItems="center" justifyContent="center">
          <CircularProgress />
        </Box>
      ) : (
        <BSBimModelList />
      )}

      {bsBimModelListByProject.length > 0 && (
        <CustomBottomNavigation
          actionLabel="Ajouter une maquette"
          validateAction={() => navigate(resolveUrl(pagesUrl.BIM_MODEL_IMPORT_PAGE, [projectId, "new"]))}
        />
      )}
    </Box>
  )
}
